/* Copyright 2020 The MathWorks, Inc. */

/**
 * This module should return an array of "types" of components that are now using the new consolidated widgets
 * in UI Framework.
 */

define([
        "dojo/_base/lang",
        "MW/toolstrip/hashes/listOfNewWidgets",
        "MW/statusbar/hashes/listOfNewWidgets"
], function (lang, ToolstripListOfNewWidgets, StatusBarListOfNewWidgets) {
    
    var list = [];

    list = list.concat(ToolstripListOfNewWidgets);
    list = list.concat(StatusBarListOfNewWidgets);

    return list;
});